var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLearn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentcolor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.77 2.526a2.75 2.75 0 0 1 2.46 0l5.658 2.83a1 1 0 0 1 0 1.788l-2.138 1.07v2.48c0 .931-.526 1.783-1.359 2.199a7.583 7.583 0 0 1-6.782 0 2.458 2.458 0 0 1-1.359-2.199v-2.48L2 7.589V12a.75.75 0 0 1-1.5 0V6.25c0-.192.072-.366.19-.499a.988.988 0 0 1 .422-.395l5.658-2.83Zm2.46 7.448 2.02-1.01v1.73a.958.958 0 0 1-.53.857 6.082 6.082 0 0 1-5.44 0 .958.958 0 0 1-.53-.857v-1.73l2.02 1.01a2.75 2.75 0 0 0 2.46 0Zm-.671-6.106a1.25 1.25 0 0 0-1.118 0L2.677 6.25l4.764 2.382a1.25 1.25 0 0 0 1.118 0l4.764-2.382-4.764-2.382Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLearn);
export default ForwardRef;